// in ./ResetViewsButton.js
import * as React from "react";
import { Link } from 'react-router-dom';
import { Button } from 'react-admin';

const ButtonCreateClient = () => {
    return (      
      <Button
        component={Link}
        label='Create Client'
        to={`/client/create`}
      >
      </Button>
    );
};

export default ButtonCreateClient;